import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { ActivoFijo } from '../../../models/activo-fijo';
import { Pagination } from '../../../models/pagination';
import { ActivoFijoService } from '../../../services/activo-fijo.service';

@Component({
  selector: 'app-activo-fijo-modal',
  templateUrl: './activo-fijo-modal.component.html',
  styleUrls: ['./activo-fijo-modal.component.css'],
  providers: [
    ActivoFijoService
  ]
})
export class ActivoFijoModalComponent implements OnInit {
  @Output() sendActivo = new EventEmitter();

  public loading: boolean;
  public activos: Array<any>;
  public busqueda: string;
  public selectedRow: Number;
  public pagination: Pagination;
  public activo_fijo: ActivoFijo;
  public format_decimal: string;
  constructor(
    private activoFijoService: ActivoFijoService,
    public bsModalRef: BsModalRef,

  ) {

    this.loading = false;
    this.activos = [];
    this.busqueda = "";
    this.pagination = new Pagination();
    this.activo_fijo = new ActivoFijo();
    this.format_decimal = "0,0.00";
  }

  ngOnInit() {
    let qs = "";
    let p1 = this.getActivos(qs);
    this.loading = true;
    Promise.all([p1]).then(
      res => this.loading = false,
      err => this.loading = false
    )

  }
  getQs() {
    return "&q[nombre]=" + this.busqueda;
  }
  getActivos(qs) {
    return new Promise((resolve, reject) => {
      this.activoFijoService.getAll("?page=" + this.pagination.current_page + "&per_page=50&sort=-id&embed=tipoactivofijo" + qs).subscribe(

        res => {
          this.activos = res.data
          this.pagination.current_page = res.current_page;
          this.pagination.from = res.from;
          this.pagination.to = res.to;
          this.pagination.total = res.total;
          this.pagination.last_page = res.last_page;
          this.pagination.next_disabled = (this.pagination.current_page === this.pagination.last_page);
          this.pagination.prev_disabled = this.pagination.current_page === 1;
          resolve();
        }, err => {
          reject(err);
        }
      );
    });
  }

  onSelectRow(tipo, i) {
    //Asignacion de fila
    this.selectedRow = i;
    //Asignacion de usuario
    this.activo_fijo = tipo;
  }

  onDBLClick(usuario, i) {
    this.onSelectRow(usuario, i);
    this.onSubmit();
  }

  onSearch(event) {
    this.busqueda = event;
    let qs = "";
    if (this.busqueda != "") {
      qs = this.getQs();
    }
    this.loading = true;
    let id = "";
    this.getActivos(qs).then(
      res => this.loading = false,
      err => this.loading = false
    );

  }

  onSubmit() {
    //si existe lote seleccionado
    if (this.activo_fijo) {
      //envía de objecto usuario
      this.sendActivo.emit(this.activo_fijo);
      this.bsModalRef.hide();
    } else {
      //Cierre de modal o componente
      this.bsModalRef.hide();
    }
  }

  next() {
    let qs = "";
    if (this.busqueda != "") {
      qs = this.getQs();
    }
    this.pagination.current_page++;
    this.getActivos(qs);
  }

  prev() {
    let qs = "";
    if (this.busqueda != "") {
      qs = this.getQs();
    }
    this.pagination.current_page--;
    this.getActivos(qs);
  }

  first() {
    let qs = "";
    if (this.busqueda != "") {
      qs = this.getQs();
    }
    this.pagination.current_page = 1;
    this.getActivos(qs);
  }

  last() {
    let qs = "";
    if (this.busqueda != "") {
      qs = this.getQs();
    }
    this.pagination.current_page = this.pagination.last_page;
    this.getActivos(qs);
  }

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/activo-fijo-modal/activo-fijo-modal.component.ts